jQuery.fn.scrollTo = function (elem, speed) {
	$(this).animate({
		scrollTop: $(this).scrollTop() - $(this).offset().top + elem.offset().top
	}, speed == undefined ? 1000 : speed);
	return this;
};

function unique(array) {
	return $.grep(array, function (el, index) {
		return index === $.inArray(el, array);
	});
}

$.fn.shuffle = function () {
	var a = this.get(),
		b = function (a) {
			return Math.floor(Math.random() * a)
		},
		c = $.map(a, function () {
			var c = b(a.length),
				d = $(a[c]).clone(!0)[0];
			return a.splice(c, 1), d
		});
	return this.each(function (a) {
		$(this).replaceWith($(c[a]))
	}), $(c)
};

$.fn.wrap_videos = function () {
	this.each(function () {
		$(this).wrap('<div class="videoWrapper"></div>');
	});
}

//lock window for mobile / full screen els
window_scroll_lock = {
	state: false,
	lock: function () {
		window_scroll_lock.state = $(window).scrollTop();
		$('body').addClass('is-blur');
	},
	unlock: function () {
		$('body').removeClass('is-blur');
		$(window).scrollTop(window_scroll_lock.state);
	}
};

customer = {
	adresses: function () {
		var select = $('[name="address[country]"]');
		select.each(function () {
			var def = $(this).attr('data-default');
			$(this).val(def);
		});


		$('[data-delete-address]').click(function (e) {
			e.preventDefault();
			Shopify.CustomerAddress.destroy($(this).attr('data-delete-address'), '')
		});

		$('[data-id]').click(function (e) {
			e.preventDefault();
			$('.ac__adress_block').hide().filter('[data-address="' + $(this).attr('data-id') + '"]').show();
		});

		$('[data-address="cancel"]').click(function (e) {
			e.preventDefault();
			$('.ac__adress_block').hide().filter('[data-address="new"]').show();
		});
	}
};

//////header
nav = {
	notibar: function () {

		new Swiper('.js-n-bar', {
			loop: true,
			slidesPerView: 1,
			spaceBetween: 0,

		});
	},

	bind: function () {
		var $search = $('.m-header__search');
		//search
		$('[data-search="show"]').click(function (e) {
			e.preventDefault();
			$search.addClass('is-active');
			setTimeout(function () {
				$search.find('input').focus();
				$('body').bind('click', function (e) {
					$search.removeClass('is-active')
					$('body').unbind('click');
				});
			}, 200);
		});
		$search.click(function (e) {
			e.stopPropagation();
		});
		//mobile nav
		$('.mb-nav-block--true .init').click(function (e) {
			e.preventDefault();
			var $t = $(this),
				$menus = $('.mb-nav-block__items');
			if ($t.hasClass('is-active')) {
				$t.removeClass('is-active');
				$menus.slideUp(200);
			} else {
				$menus.slideUp(200);
				$('.mb-nav-block--true .init').removeClass('is-active');
				$t.addClass('is-active').next('.mb-nav-block__items').slideDown(200);
			}
		});

		// scroll state event
		$(window).on('scroll load resize', function () {
			var windowWidth = $(window).width();

			if (windowWidth >= 990) {
				if ($(window).scrollTop() > 0) {
					$('.m-header').addClass('is-scrolled');
					$('.p-main--custom').addClass('is-scrolled');
					$('p-main__images-wrapper').addClass('p-main__images');
				} else {
					$('.m-header').removeClass('is-scrolled');
					$('.p-main--custom').removeClass('is-scrolled');
				}
			} else {
				// Ensure classes are removed on smaller screens
				$('.m-header').removeClass('is-scrolled');
				$('p-main__images-wrapper').removeClass('p-main__images');
				$('.p-main--custom').removeClass('is-scrolled');
			}
		});
	},
};

//image accent popout
ac_image = {
	bind: function () {
		$('[data-acnt_img]').mouseenter(function () {

		});
	}
};

//modal video player
modal = {
	bind: function () {
		$('.mdl__close-ico').click(function (e) {
			e.preventDefault();
			modal.close();
		});
		modal.video.bind();
	},
	open: function (target) {
		$('.mdl__content').hide().filter(target).show();
		$('.mdl').fadeIn(200);
	},
	close: function () {
		$('.mdl').fadeOut(200);
		if (modal.video.modal_player && modal.video.modal_player != null) {
			modal.video.modal_player.pauseVideo();
		}
	},
	f_config: {
		persist: 'shared'
	},
	newsletter: {
		init: function (seconds) {
			var timeout = parseInt(seconds, 10);
			if (!$.cookie('rsf_newsletter_signup__1122')) {
				$.cookie('rsf_newsletter_signup__1122', true, {expires: 31});
				setTimeout(function () {
					$.featherlight($('[data-modal="newsletter"]'), modal.f_config);
					//ajax_form.bind($('[data-ajaxform="popout"]'),modal.newsletter.close);
				}, timeout);
			}
			;
		},
		close: function () {
			var $cur = $.featherlight.current();
			if ($cur != null) {
				$cur.close();
			}
			;
		},
	},
	video: {
		bind: function () {
			$(document).on('click', '[data-modal_video_id]', function (e) {
				e.preventDefault();
				modal.video.build_modal($(this).attr('data-modal_video_id'), 'mdl-video');
			});
		},
		build_modal: function (id, target) {
			if (!modal.video.modal_player || modal.video.modal_player === null) {
				modal.video.modal_player = new YT.Player(target, {
					height: '720',
					width: '1280',
					playerVars: {
						'PlaybackQuality': 'highres',
						'rel': 0,
						'loop': 0,
						'controls': 1,
						'showinfo': 0,
						'enablejsapi ': 1,
						'wmode': 'opaque',
						'playlist': id
					},
					videoId: id,
					events: {
						'onReady': function () {
							modal.video.modal_player.playVideo();
							modal.open('#' + target);
						}
					}
				});
			} else {
				modal.video.modal_player.cueVideoById({videoId: id});
				modal.video.modal_player.playVideo();
				modal.open('#' + target);
			}
			;
		},
	},
};

//Instagram
insta_feed = {
	init: function (token) {
		//instagram feed
		var url = "https://api.instagram.com/v1/users/self/media/recent/?access_token=" + token;
		var fetcher, renderer, instaComplete;
		insta_feed.count = 0;
		insta_feed.fetcher(url);
	},
	fetcher: function (url) {
		$.ajax({
			type: "GET",
			dataType: "jsonp",
			url: url,
			success: function (data) {
				//pass the current pages array to be rendered
				insta_feed.renderer(data.data);
				//get the next page
				var next = data.pagination.next_url;
				if (next != null && insta_feed.count.count < 20) {
					insta_feed.fetcher(next);
				} else {
					insta_feed.instaComplete();
				}
				;
			}
		});
	},

	renderer: function (data) {
		$.each(data, function (k, v) {
			var link = v.link,
				img = v.images["low_resolution"].url,
				tags = v.tags;
			if ($.inArray('quote', tags) < 1) {
				insta_feed.count.count++
				$('.js-igramfeed__items').append('<li class="swiper-slide @mobile-tablet__block-4/12 @mobile-mobile__block-6/12"><a class="d-block bg-image bg-image--square block-12/12 lazyload" href="' + link + '" target="_blank" data-bg="' + img + '"></a></li>');
			}
			;
		});
	},

	instaComplete: function () {
		new Swiper('.js-igramfeed', {
			loop: true,
			freeMode: false,
			slidesPerView: 7,
			centeredSlides: true,
			spaceBetween: 0,
			lazy: {
				loadPrevNext: true,
				loadPrevNextAmount: 3,
			},
			preloadImages: false,
			breakpoints: {
				767: {
					slidesPerView: 5,
				}
			}
		});
	}
};


//slide out items
header_slideouts = {
	$wrap: $('.s-outs__wrap'),
	$inner: $('.s-outs__inner'),
	bind: function () {
		$('[data-slideout__open]').click(function (e) {
			e.preventDefault();
			header_slideouts.open($(this).attr('data-slideout__open'));
		});
		$('[data-slideout="close"]').click(function (e) {
			e.preventDefault();
			header_slideouts.close();
		});
	},
	open: function (target) {
		header_slideouts.$wrap.fadeIn(200, function () {
			$('[data-slideout="' + target + '"]').addClass('is-active');
			window_scroll_lock.lock();
		});
	},
	close: function () {
		header_slideouts.$inner.removeClass('is-active');
		setTimeout(function () {
			header_slideouts.$wrap.fadeOut(200);
			window_scroll_lock.unlock();
		}, 400);
	},
};

qnt_input = {
	bind: function () {
		$(document).on('click', '.qnt_input span', function () {
			var t = $(this),
				a = t.closest('.qnt_input').find('input'),
				b = a.val(),
				b = parseInt(b, 10),
				c = parseInt(a.attr('min'), 0),
				d = parseInt(a.attr('max'), 0),
				x = b + 1,
				y = b - 1
			if (t.hasClass('plus')) {
				if (b <= d - 1 || d === null || !d) {
					a.val(x).trigger('change');
				}
				;
			} else {
				if (y >= c) {
					a.val(y).trigger('change');
				}
				;
			}
			;
		});
	}
};

//product accoridan
slideout_accordian = {
	init: function () {
		var $container = $('[data-accordian="titles"]');
		$('[data-accoridan_anchor]').each(function () {
			var t = $(this),
				anchor = t.attr('data-accoridan_anchor'),
				el = '<a data-accordian_title="' + anchor + '" data-slideout__open="product__accordian" class="product-form__accordion-item" href="#">' + t.text() + '</a>';
			let secEl = '<span class="product-form__accordion-item-splitter">|</span>';
			$container.append(el);
			$container.append(secEl);
		});
		$container.append('<a class="product-form__accordion-item" href="https://sho.helpscoutdocs.com/" target="_blank">FAQs</a>');

		$('[data-accordian_title]').click(function (e) {
			e.preventDefault();
			var $t = $(this);
			setTimeout(function () {
				var $target = $t.attr('data-accordian_title'),
					$target = $('[data-accoridan_anchor="' + $target + '"]'),
					top = $target.offset().top - 0,
					$inner = $('[data-slideout="product__accordian"] .__inner');
				$inner.scrollTo($target, 500);
			}, 800);
		});

	},
};

//////prouduct gallery
wbsk_gallery = (function () {
	var _this = {
		gal_options: {
			bgOpacity: 0.7,
			showHideOpacity: true
		},
		pi_gal: function (array) {
			_this.gal_link = $('.js-psp-pi-gal');
			_this.items = array;
			if (_this.items.length < 0) {
				_this.gal_link.hide();
			} else {
				_this.gal_link.click(function (e) {
					e.preventDefault();
					var options = _this.gal_options;
					options.index = 0;
					var lightBox = new PhotoSwipe($('.pswp')[0], PhotoSwipeUI_Default, _this.items, options);
					lightBox.init();
				});
			}
			;

		},
	};
	return _this;
})();

//gallery for custom products
wbsk_custom_prods_gallery = (function () {
	var _this = {
		init: function () {
			new Swiper('.js-customizer-gal', {
				loop: true,
				freeMode: false,
				slidesPerView: 4.5,
				centeredSlides: true,
				spaceBetween: 45,
				lazy: {
					loadPrevNext: true,
					loadPrevNextAmount: 2,
				},
				preloadImages: true,
				navigation: {
					nextEl: '.swiper-button-next',
					prevEl: '.swiper-button-prev',
				},
				breakpoints: {
					767: {
						slidesPerView: 2,
					}
				}
			});
		},
	};
	return _this;
})();

//////product upsell
wbsk_product_upsell = (function () {
	var _this = {
		active: false,
		total: 0,
		map_upsells: function () {
			var $active = $('.js-pup-thumb.__active');
			_this.total = 0;
			if ($active.length > 0) {
				_this.table.empty().show();
				_this.active = [];
				$active.each(function () {
					var $data = {},
						$t = $(this);
					$data.id = $t.data('id');
					$data.price = $t.data('price');
					$data.title = $t.data('title');
					_this.active.push($data);
				});
				_this.build_list();
			} else {
				_this.active = false;
				_this.table.empty().hide();
			}
			;
			$('.js-wbsk-product-form').data('wbskProductForm').update(true)
		},

		build_list: function () {
			$.each(_this.active, function (k, v) {
				var html = '<div class="flex row-wrap align-center justify-space cb--xs">\
            <div> + ' + v.title + '</div>\
			<div><span class="money">' + Shopify.formatMoney(v.price) + '</span></div>';
				_this.table.append(html);
				_this.total = _this.total + parseInt(v.price, 0)
			});
		},

		init: function () {
			new Swiper('.js-upsell-slider', {
				loop: true,
				freeMode: false,
				slidesPerView: 3,
				centeredSlides: true,
				spaceBetween: 15,
				lazy: {
					loadPrevNext: true,
					loadPrevNextAmount: 2,
				},
				preloadImages: true,
				navigation: {
					nextEl: '.swiper-button-next',
					prevEl: '.swiper-button-prev',
				},
				breakpoints: {
					767: {
						slidesPerView: 2,
					}
				}
			});

			_this.bind();
		},

		bind: function () {
			_this.table = $('.js-upsells_table');
			_this.form = _this.table.closest('form');
			$('.js-pup-thumb').click(function (e) {
				e.preventDefault();
				$(this).toggleClass('__active');
				_this.map_upsells();
			});
		},
	};
	return _this;
})();


//////pages

wbsk_index = (function () {
	var _this = {
		init: function () {
			_this.product_slider();
			_this.blog_slider();
		},

		hero_slider: function () {

			var hero_slider = new Swiper('.js-index_hero', {
				loop: true,
				slidesPerView: 1,
				spaceBetween: 0,
				autoHeight: true,
				preloadImages: false,
				lazy: {
					loadPrevNext: true,
					loadPrevNextAmount: 0,
				},
				navigation: {
					nextEl: '.swiper-button-next',
					prevEl: '.swiper-button-prev',
				},
			});
			hero_slider.on('lazyImageReady', function () {
				hero_slider.updateAutoHeight();
			});
		},

		product_slider: function () {
			new Swiper('.js-p-slider', {
				loop: true,
				freeMode: false,
				slidesPerView: 1.75,
				centeredSlides: true,
				spaceBetween: 0,
				lazy: {
					loadPrevNext: true,
					loadPrevNextAmount: 4,
				},
				preloadImages: true,
				navigation: {
					nextEl: '.swiper-button-next',
					prevEl: '.swiper-button-prev',
				},
				breakpoints: {
					767: {
						slidesPerView: 1,
					}
				}
			});
		},

		blog_slider: function () {
			new Swiper('.js-feat_blog', {
				loop: true,
				freeMode: false,
				slidesPerView: 4,
				centeredSlides: true,
				spaceBetween: 15,
				lazy: {
					loadPrevNext: true,
					loadPrevNextAmount: 2,
				},
				preloadImages: true,
				navigation: {
					nextEl: '.swiper-button-next',
					prevEl: '.swiper-button-prev',
				},
				breakpoints: {
					1180: {
						slidesPerView: 4,
					},
					1024: {
						slidesPerView: 3,
					},
					767: {
						slidesPerView: 2,
					},
					480: {
						slidesPerView: 1,
					}
				}
			});
		},
	};
	return _this;
})();

wbsk_collection = (function () {
	var _this = {
		init: function () {
			$('[data-collection_update="sort"]').change(function () {
				window.location.href = window.location.href.split("?")[0] + "?" + $(this).val();
			});
		},
	};
	return _this;
})();

wbsk_blog = (function () {
	var _this = {
		init: function () {
			var $feed = $('.b-main');
			$feed.imagesLoaded(function () {
				$feed.isotope({});
			});
		},

	};
	return _this;
})();

/*not used
wbsk_article = (function(){
  var _this = {

  };
  return _this;
})();
*/

wbsk_charity = (function () {
	var _this = {
		init: function () {
			_this.slider = new Swiper('.js-charity-slider', {
				loop: true,
				slidesPerView: 3.5,
				spaceBetween: 7,
				autoHeight: false,
				lazy: {
					loadPrevNext: true,
					loadPrevNextAmount: 2,
				},
				breakpoints: {
					767: {
						slidesPerView: 2.5,
					},
					480: {
						slidesPerView: 1.5,
					}
				}
			});
		}
	};
	return _this;
})();


//product aboe fold image gallery
wbsk_product_gallery = (function () {
	var _this = {

		init: function (variantId) {
		
			_this.slider(variantId);
			_this.popout_gal();
		},

		updateByVariantId: function (variantId) {
			//console.log("here updateBy Variant: ", variantId )
			var slide_index = $('img[data-var_id ="' + variantId + '"]').first().closest('.swiper-slide').index();
			
			//slide_index = parseInt(slide_index,0) + 1;
			if ($('.js-product_imgs').length > 0) {
				_this.featured_slider.slideTo(slide_index, 0);
				//ugly fix for swiper going to wrong slide bug - this is not a duplicate - do not delete!
				_this.featured_slider.slideTo(slide_index, 0);
			}

			if ($('.js-product_imgs--custom').length > 0) {
		
				//slide_index = parseInt(slide_index,0) + 1;
				_this.featured_slider_custom.slideTo(slide_index, 0);
				//ugly fix for swiper going to wrong slide bug - this is not a duplicate - do not delete!
				_this.featured_slider_custom.slideTo(slide_index, 0);
			}

		},

		resize_thumbs: function () {
			
			if ($('.js-product_imgs').length > 0) {
				 $('.js-product_thumbs').height($('.js-product_imgs li').height()); 
				_this.thumb_slider.update();
				_this.featured_slider.update();
			}

			if ($('.js-product_imgs--custom').length > 0) {
				 $('.js-product_thumbs--custom').height($('.js-product_imgs--custom li').height()); 
				_this.thumb_slider_custom.update();
				_this.thumb_slider_custom.updateSize();
				_this.thumb_slider_custom.updateSlides();
				_this.thumb_slider_custom.updateSlidesClasses();
				_this.featured_slider_custom.update();
				_this.featured_slider_custom.updateSize();
				_this.featured_slider_custom.updateSlides();
				_this.featured_slider_custom.updateSlidesClasses();
				
			}

		},

		slider: function (variantId) {
			//thumb slider
			_this.thumb_slider = new Swiper('.js-product_thumbs', {
				//loop: true,
				slidesPerView: 6,
				spaceBetween: 12,
				direction: 'vertical',
				centeredSlides: false,
				slideToClickedSlide: true,
				lazy: {
					loadPrevNext: true,
					loadPrevNextAmount: 1,
				}
			});

			//main slider
			_this.featured_slider = new Swiper('.js-product_imgs', {
				centeredSlides: true,
				slidesPerView: 1,
				spaceBetween: 0,
				autoHeight: true,
				updateOnWindowResize: true,
				lazy: {
					loadPrevNext: true,
					loadPrevNextAmount: 1,
				},
				navigation: {
					nextEl: '.swiper-button-next',
					prevEl: '.swiper-button-prev',
				},
				breakpoints: {
					767: {
						slidesPerView: 1,
					},
				}
			});
		

			//thumb slider customized pdp
			_this.thumb_slider_custom = new Swiper('.js-product_thumbs--custom', {
				//loop: true,
				slidesPerView: 6,
				spaceBetween: 12,
				direction: 'vertical',
				//allowTouchMove: true,
				centeredSlides: false,
				slideToClickedSlide: true,
				lazy: {
					loadPrevNext: true,
					loadPrevNextAmount: 1
				},
				navigation: {
					nextEl: '.swiper-button-next.thumbs',
					prevEl: '.swiper-button-prev.thumbs'
				}
			});
			window.mySwiperThumbs = _this.thumb_slider_custom;
			//main slider customized pdp
			_this.featured_slider_custom = new Swiper('.js-product_imgs--custom', {
				centeredSlides: true,
				slidesPerView: 1,
				spaceBetween: 0,
				initialSlide: 1,
				autoHeight: false,
				updateOnWindowResize:true,
				
				lazy: {
					loadPrevNext: true,
					loadPrevNextAmount: 5,
				},
				navigation: {
					nextEl: '.swiper-button-next',
					prevEl: '.swiper-button-prev'
				},
				pagination: {
					el: '.swiper-pagination',
					clickable: true
				},
				on: {
					slideChange: function () {
						let currentSlide = this.realIndex + 1;
						document.querySelector('.current-slide').innerHTML = currentSlide;
					},
					beforeInit: function () {
						let numOfSlides = this.wrapperEl.querySelectorAll(".swiper-slide").length;
						document.querySelector('.total-slides').innerHTML = numOfSlides;
					},
					breakpoint: function () {
						
						let numOfSlides = this.wrapperEl.querySelectorAll(".swiper-slide").length;
						document.querySelector('.total-slides').innerHTML = numOfSlides;
					  },
					  afterInit: function(){
						let numOfSlides = this.wrapperEl.querySelectorAll(".swiper-slide").length;
						document.querySelector('.total-slides').innerHTML = numOfSlides;
					  }
				},
				breakpoints: {
					767: {
						slidesPerView: 1,
						on: {
							afterInit: function(){
								let numOfSlides = this.wrapperEl.querySelectorAll(".swiper-slide").length;
								document.querySelector('.total-slides').innerHTML = numOfSlides;
							  },
							  slideChange: function () {
								console.log("here index ", this.realIndex)
							
							},
						},
					}
				}
			});
			window.mySwiper = _this.featured_slider_custom;
			
			setTimeout(() => {
				//console.log("_this.featured_slider_custom: ", _this.featured_slider_custom)
				_this.featured_slider_custom.slideTo(0, 0);

				$('.p-custom__color-group input').each((index, element) => {

					$(element).on('change', () => {
						
						
						_this.featured_slider_custom.slideTo(0, 0);
						const urlParams = new URLSearchParams(window.location.search);

						// Get the "variant" parameter value
						const variantParam = urlParams.get("variant");
						const variantId = parseInt(variantParam, 10)
						//console.log("variant click ", variantId)
						function isMobile() {
							return window.innerWidth <= 3000; 
						}
						if (isMobile()) {
			
							var data = theme.customProductParts[0];
							// Filter the variants object based on selected_variant_id
							const filteredVariant = data.variants.find(variant => variant.id === variantId);
			
							// Get the variant_images array from the filtered variant
							const variantImages = filteredVariant ? filteredVariant.variant_images : [];
			
							const numberOfSlides = _this.featured_slider_custom.slides.length;
			
							// Create an array of slide indices to remove, starting from the second slide to the last slide
							const indicesToRemove = [];
							for (let i = 1; i < numberOfSlides; i++) {
								indicesToRemove.push(i);
							}
							indicesToRemove.forEach(index => {
								const slide = _this.featured_slider_custom.slides[index];
								if (slide) {
									slide.classList.add('hidden');
								}
							});
							// // Remove the slides
							_this.featured_slider_custom.removeSlide(indicesToRemove);
			
							variantImages.forEach((image, index) => {
							const slideContent = `<li class="block-12/12 swiper-slide js-psp_product variant_images">
													<figure class="d-block block-12/12 block-c" itemprop="associatedMedia" itemscope="" itemtype="http://schema.org/ImageObject">
														<a class="d-block block-12/12" href="#" itemprop="contentUrl" data-size="2048x1365.0" >
															<img class="block-12/12" alt="" src="${image.image_src}" loading="lazy" data-sizes="auto" data-srcset="${image.image_src}" >
														</a>
													</figure>
												</li>`;
								_this.featured_slider_custom.addSlide(1, slideContent);
							});
							// Update the Swiper instance
							_this.featured_slider_custom.update();
							//console.log("hereeeee update")
							const numberOfSlides2 = variantImages.length;
							document.querySelector('.total-slides').innerHTML = numberOfSlides2 + 1;
						}else{
							// Remove slides with the class "variant_images"
							const slides = _this.featured_slider_custom.$el.find('.variant_images');
							slides.remove();
							_this.featured_slider_custom.slides.removeClass('hidden');
							_this.featured_slider_custom.update();
						}
						// end logic
						
						
					})
				})
			}, 0);
			
			
			

			_this.featured_slider_custom.on('lazyImageReady', function () {
				_this.featured_slider_custom.updateAutoHeight()
				
			});

			_this.featured_slider_custom.on('slideChange', function () {
				_this.thumb_slider_custom.slideTo(_this.featured_slider_custom.activeIndex, 0);
			   $(_this.thumb_slider_custom.slides[_this.featured_slider_custom.activeIndex]).addClass('swiper-slide-active').siblings().removeClass('swiper-slide-active');
				
			});

			// _this.featured_slider_custom.on('slideChange', function () {
			// 	//_this.thumb_slider_custom.slideTo(_this.featured_slider_custom.activeIndex, 0);
			// 	//$(_this.thumb_slider_custom.slides[_this.featured_slider_custom.activeIndex]).addClass('swiper-slide-active').siblings().removeClass('swiper-slide-active');
			// 	console.log("here 3")
			// });
			//console.log("slider custom:",_this.thumb_slider_custom, _this.featured_slider_custom)
			/*_this.featured_slider_custom.controller.control = _this.thumb_slider_custom;
            _this.thumb_slider_custom.controller.control = _this.featured_slider_custom;*/

			_this.thumb_slider_custom.on('click', function () {

				var index = this.clickedIndex;
				if (index != null) {
					_this.featured_slider_custom.slideTo(index, 0);
				}

			});

			_this.thumb_slider_custom.on('slideChange', function () {
				
				_this.featured_slider_custom.slideTo(_this.thumb_slider_custom.activeIndex, 0);
			});

			_this.featured_slider.on('lazyImageReady', function () {
				
				_this.featured_slider.updateAutoHeight()
			});

			_this.featured_slider.on('slideChange', function () {
				
				_this.thumb_slider.slideTo(_this.featured_slider.activeIndex, 0);
				$(_this.thumb_slider.slides[_this.featured_slider.activeIndex]).addClass('swiper-slide-active').siblings().removeClass('swiper-slide-active');
			});

			_this.featured_slider.on('slideChange', function () {
				
				_this.thumb_slider.slideTo(_this.featured_slider.activeIndex, 0);
				$(_this.thumb_slider.slides[_this.featured_slider.activeIndex]).addClass('swiper-slide-active').siblings().removeClass('swiper-slide-active');
			});

			_this.thumb_slider.on('click', function () {
				
				var index = this.clickedIndex;
				if (index != null) {
					_this.featured_slider.slideTo(index, 0);
				}
			});
			
			_this.thumb_slider.on('slideChange', function () {
				
				_this.featured_slider.slideTo(_this.thumb_slider.activeIndex, 0);
			});
			
			_this.updateByVariantId(variantId)

			//resize events
			$(window).on('load resize', function () {
				_this.resize_thumbs();
				//_this.featured_slider_custom.update();
				
			});
			_this.resize_thumbs();

		},

		popout_gal: function () {
			_this.items = _this.get_gallery_array();
			$('.js-psp_product').click(function (e) {
				e.preventDefault();
				var options = _this.gal_options;
				options.index = $(this).index() ;
				var lightBox = new PhotoSwipe($('.pswp')[0], PhotoSwipeUI_Default, _this.items, options);
				lightBox.init();
			});

		},

		gal_options: {
			bgOpacity: 0.7,
			showHideOpacity: true
		},

		get_gallery_array: function () {
			var items = [];

			if ($('.js-product_imgs li figure a').length <= 0) {
				$('.js-product_imgs--custom li figure a').each(function () {
					var $size = $(this).data('size').split('x');
					var item = {
						src: $(this).attr('href'),
						w: $size[0],
						h: $size[1]
					};
					items.push(item);
				});
			} else {
				$('.js-product_imgs li figure a').each(function () {
			
					var $size = $(this).data('size').split('x');
					var item = {
						src: $(this).attr('href'),
						w: $size[0],
						h: $size[1]
					};
					items.push(item);
				});
			}

			return items;
		},
	}
	return _this
})()


wbsk_product = (function () {
	var _this = {

		init: function (variant) {
			wbsk_product_gallery.init(variant.id);
			_this.bind()
		},

		bind: function () {
			$('.ruk_rating_snippet').on('click', function (e) {
				e.preventDefault()
				$('html, body').animate({
					scrollTop: $(".p-accordian").offset().top
				}, 1000);
			})
		},

		rel_products: function () {
			$('.js-rel-products li.swiper-slide').shuffle();
			new Swiper('.js-rel-products', {
				loop: false,
				freeMode: false,
				slidesPerView: "auto",
				centeredSlides: false,
				spaceBetween: 16,
				lazy: true,
				breakpointsInverse: true,
				preloadImages: true,
				breakpoints: {
					768: {
						spaceBetween: 35
					},
					992: {
						spaceBetween: 50
					}
				},
				scrollbar: {
					el: "[data-slider-scrollbar]",
					draggable: true
				}
			});
		},


		accordian: function () {
			$('.p-accordian__nav li:first').addClass('is-active');
			$('.p-accordian__content-item:first').show();
			$('.p-accordian__nav li a').click(function (e) {
				e.preventDefault();
				var $parent = $(this).parent('li');
				$parent.addClass('is-active').siblings('li').removeClass('is-active');
				$('.p-accordian__content-item').hide().eq($parent.index()).show();
			});
		},

		gallery: function () {
			//js-p-gallery
			new Swiper('.js-p-gallery', {
				loop: true,
				freeMode: false,
				slidesPerView: 1,
				centeredSlides: true,
				spaceBetween: 0,
				lazy: true,
				preloadImages: false,
				navigation: {
					nextEl: '.swiper-button-next',
					prevEl: '.swiper-button-prev',
				},

			});

		},

		hotspots: function () {
			$('.p-meta__interactive-overlay li').click(function () {
				var $t = $(this);
				if ($t.hasClass('is-active')) {
					$t.removeClass('is-active')
				} else {
					$t.addClass('is-active').siblings().removeClass('is-active');
				}
				;
			});
		},

	};
	return _this;
})();


$(function () {
	//$('iframe[src*="vimeo"],iframe[src*="youtube"]').wrap_videos();
	nav.bind();
	header_slideouts.bind();
	modal.bind();
	//AOS.init();
	FastClick.attach(document.body);
	insta_feed.init("{{settings.instagram_access_token}}");
});
